export default __webpack_public_path__ + "pdf/Andy_Lomas.0994561.pdf";